export default __webpack_public_path__ + "static/media/customArrow.d760378a.svg";